import React, { useState } from "react";
import { PageHeading } from "../../components/PageHeading/PageHeading";
import { PageContent } from "../../components/PageContent/PageContent";
import { useDataApiClient } from "../../hooks/useApiClient";
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  VStack,
} from "@chakra-ui/react";
import { CherryHubDataApi } from "../../api/dataApiModels";
import { TestDocumentIcon } from "../../styles/icons";
import { Form, Formik } from "formik";
import { useToast } from "../../hooks/useToast";

export const TestCertificate = () => {
  const apiClient = useDataApiClient();

  const handleClick = () => setShow(!show);
  const [show, setShow] = React.useState(false);
  const [file, setFile] = useState<File>();
  const [password, setPassword] = useState<string>("");
  const [response, setResponse] = useState<[key: string]>();
  const { showErrorToast } = useToast();

  const [certificates, setCertificates] =
    useState<CherryHubDataApi.APSCExpirationStatus>();

  const testCertificate = async () => {
    if (file == undefined) return;
    const result = await apiClient.testApplePassCertificate(password, file);
    if (result.ok) {
      setResponse(result.data as [key: string]);
    } else {
      showErrorToast(result.message);
    }
  };

  return (
    <>
      <PageHeading>
        <PageHeading.Title>Test Certificate</PageHeading.Title>
      </PageHeading>
      <PageContent>
        <Formik
          initialValues={{}}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              testCertificate();
              actions.setSubmitting(false);
            }, 1000);
          }}
        >
          {(props) => (
            <Form style={{ width: "100%" }}>
              <VStack width="100%" spacing={4} alignItems="flex-start">
                <FormControl isRequired>
                  <FormLabel>Certificate :</FormLabel>
                  <Input
                    type="file"
                    onChange={(e) =>
                      setFile(
                        (e.target.files?.length && e.target?.files[0]) ||
                          undefined
                      )
                    }
                    maxW="sm"
                  />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Password :</FormLabel>
                  <InputGroup maxW="sm">
                    <Input
                      pr="4.5rem"
                      type={show ? "text" : "password"}
                      placeholder="Enter password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <InputRightElement width="4.5rem" h="100%">
                      <Button size="xs" onClick={handleClick}>
                        {show ? "Hide" : "Show"}
                      </Button>
                    </InputRightElement>
                  </InputGroup>
                </FormControl>
                <Button
                  type="submit"
                  leftIcon={<TestDocumentIcon />}
                  colorScheme="cherryButton"
                  isLoading={props.isSubmitting}
                >
                  Test Certificate
                </Button>
              </VStack>
            </Form>
          )}
        </Formik>

        {response && (
          <Box
            width="100%"
            borderWidth="1px"
            borderRadius="lg"
            overflowX="auto"
            padding={6}
          >
            <Text>Result:</Text>
            <Divider />
            <pre>{JSON.stringify(response, null, 2)}</pre>
          </Box>
        )}
      </PageContent>
    </>
  );
};
